module.exports = __webpack_public_path__ + "static/media/galeria8.d441340f.jpg";